<template>
  <div class="filters">
    <div class="filters__container">
      <div class="d-flex flex-column">
        <span class="font-weight-bold">Start date</span>
        <a-date-picker
          v-model="filters.date_start"
          format="YYYY-MM-DD HH:mm"
          :show-time="{
            defaultValue: $moment('00:00:00', 'HH:mm'),
            format: 'HH:mm'
          }"
          type="date"
          size="large"
          placeholder="Start date"
          :disabled="loading || disabled"
          @change="changeStartDate"
        />
      </div>
      <div class="d-flex flex-column">
        <span class="font-weight-bold">End date</span>
        <a-date-picker
          v-model="filters.date_end"
          format="YYYY-MM-DD HH:mm"
          :show-time="{
            defaultValue: $moment('00:00:00', 'HH:mm'),
            format: 'HH:mm'
          }"
          type="date"
          size="large"
          placeholder="End date"
          :disabled="loading || disabled"
          @change="changeEndDate"
        />
      </div>
      <UniversalSelect
        v-model="filters.status"
        style="width: 180px;"
        :options="statusOptions"
        placeholder="Status"
        title="Status"
        :disabled="loading || disabled"
        @change="changeStatusFilter"
      />
      <div class="d-flex align-items-end" style="height: 62px;">
        <SearchField
          :value="filters.name"
          :loading="loading"
          :disabled="loading || disabled"
          @search="changeSearchValue"
        />
      </div>
    </div>
  </div>
</template>

<script>
import UniversalSelect from '@/components/custom/filters/universalSelect.vue'
import SearchField from '@/components/custom/form/SearchField.vue'
import { getFilledFilters } from '@/composables/useGetFilledFilters.js'
import { setFilters } from '@/composables/useSetQueryParams.js'

export default {
  props: {
    search: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    UniversalSelect,
    SearchField,
  },
  data: () => ({
    statusOptions: [
      { name: 'Active', value: 'active' },
      { name: 'Inactive', value: 'inactive' },
      { name: 'Disabled', value: 'disabled' },
      { name: 'Completed', value: 'completed' },
    ],
    filters: {
      date_start: undefined,
      date_end: undefined,
      status: undefined,
      name: '',
    },
  }),
  computed: {
    isFiltered() {
      return Object.values(this.filters).some(v => v !== undefined && v !== null && v !== '')
    },
  },
  watch: {
    isFiltered: {
      handler(val) {
        this.$emit('update:isFiltered', val)
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    setQueryFilters(newFilters) {
      setFilters(newFilters, this, '', true)
    },
    changeStartDate() {
      this.sendFiltersEvent()
    },
    changeEndDate() {
      this.sendFiltersEvent()
    },
    changeStatusFilter() {
      this.sendFiltersEvent()
    },
    changeSearchValue(value) {
      this.filters.name = value
      this.sendFiltersEvent()
    },
    getFilters() {
      return getFilledFilters({ filters: this.filters, dateFields: ['date_start', 'date_end'] })
    },
    sendFiltersEvent() {
      const filters = this.getFilters()
      this.$emit('change', filters)
    },
    resetFilters() {
      this.filters = {
        date_start: undefined,
        date_end: undefined,
        status: undefined,
        name: '',
      }
      this.$router.push(`${this.$route.path}`)
    },
  },
}
</script>

<style lang="scss">
.filters {
  display: flex;
  gap: 10px;
  width: fit-content;
  &__container {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 10px;
  }
}
</style>
